// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__1l07G","placeholder":"styles_placeholder__3zfYl"};